import React from 'react';

import { Route } from 'react-router-dom';

export const getStoryEndpoint = (url: string) => url.replace(/\/([^/]*)$/, '');

export const mapRoutes = (routes) =>
  routes.map((route) => <Route key={route.path} {...route} />);
